import { IApplication } from "@rentiohq/shared-frontend/dist/types/application.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Modal } from "@rentiohq/web-shared/dist/components";
import * as S from "../VisitMode.styled";
import { getCandidateName } from "../visitMode.utils";

interface IProps {
  application: IApplication;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * One candidate, so there is nothing to choose: a list with a single tick asks
 * a question that answers itself. What is worth asking is whether to send at
 * all, because the mail cannot be taken back and the button that opens this
 * sits under a note field a thumb has just been typing in.
 */
export const ConfirmInviteModal = (props: IProps) => {
  const { application, onClose, onConfirm } = props;

  const candidateName = getCandidateName(application);

  return (
    <Modal
      width="small"
      heading={getLocalizedText("visit_mode.invite.confirm_single.heading")}
      hasDismiss={true}
      onClose={onClose}
      actions={[
        {
          content: getLocalizedText("system.cancel"),
          onClick: onClose,
          appearance: "outline",
        },
        {
          content: getLocalizedText("visit_mode.invite.confirm_single.action"),
          onClick: onConfirm,
          appearance: "primary",
        },
      ]}
    >
      <S.ConfirmBody>
        {getLocalizedText("visit_mode.invite.confirm_single.body", {
          name: candidateName,
        })}
      </S.ConfirmBody>
    </Modal>
  );
};
